import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatCalendar } from "@angular/material/datepicker";
import { DateAdapter } from "@angular/material/core";

@Component({
    selector: "app-calendar-header",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./calendar-header.component.html",
    styleUrl: "./calendar-header.component.scss"
})
export class CalendarHeaderComponent<D> {
    constructor(
        public calendar: MatCalendar<D>,
        private readonly dateAdapter: DateAdapter<D>,
        cdr: ChangeDetectorRef
    ) {
        calendar.stateChanges.pipe(takeUntilDestroyed()).subscribe(() => cdr.markForCheck());
    }

    get periodLabel(): string {
        const date = this.calendar.activeDate;
        const month = this.dateAdapter.getMonthNames("short")[this.dateAdapter.getMonth(date)];
        const year = this.dateAdapter.getYear(date);
        return `${month} ${year}`;
    }

    prev(): void {
        this.calendar.activeDate = this.dateAdapter.addCalendarMonths(this.calendar.activeDate, -1);
    }

    next(): void {
        this.calendar.activeDate = this.dateAdapter.addCalendarMonths(this.calendar.activeDate, 1);
    }
}
